import React, { Component } from 'react';
import config from '../views/config/App_data';
import postData from '../views/RestAPI/fetchData';
import getData from '../views/RestAPI/getDataService';
import { showFailure, showSuccess } from '../common/toast';
import { messages } from '../common/messages';
import { API_ENDPOINT } from '../common/apiEndPoints';

class EmailResubscribe extends Component {
  state = {
    isUserSubscribed: true,
  };

  async componentDidMount() {
    const { isUserSubscribed } = await getData.callAPI(API_ENDPOINT.GET_SENDGRID_STATUS);
    this.setState({ isUserSubscribed });
  }

  handleResubscribe = async () => {
    const { isUserSubscribed, message } = await postData.callAPI(API_ENDPOINT.RESUBSCRIBE_SENDGRID);
    this.setState({ isUserSubscribed }, () => {
      isUserSubscribed ? showSuccess(message) : showFailure(message);
    });
  };

  render() {
    const { isUserSubscribed } = this.state;

    return (
      !isUserSubscribed && (
        <div className='email-resubscribe-link text-right'>
          <span className='font-xs font-lusitana'>
            📢 {messages.EMAIL_UNSUBSCRIBED}
            <b
              className='text-primary cursor-pointer'
              onClick={this.handleResubscribe}
            >
              {messages.CLICK_TO_RESUBSCRIBE}
            </b>
          </span>
        </div>
      )
    );
  }
}

export default EmailResubscribe;



// WEBPACK FOOTER //
// ./src/components/EmailResubscribe.jsx